export default __webpack_public_path__ + "static/media/pic3.c8bb0487.jpg";